import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDocumentTitle, useSectionTranslation } from '@/hooks';
import { Header } from '@/features/home/Header';
import { Footer } from '@/features/home/Footer';
import { Menu } from 'lucide-react';
import { dashboardNavGroups, quickNavItems } from './navigation';
import { dashboardTranslations } from './translations';
import { CommandPalette } from './components/CommandPalette';
import { MobileNavigation } from './components/MobileNavigation';
import { Sidebar } from './components/Sidebar';

export function DashboardPage() {
  const t = useSectionTranslation(dashboardTranslations);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [commandOpen, setCommandOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useDocumentTitle(t.title);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const mod = event.metaKey || event.ctrlKey;
      if (mod && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setCommandOpen(true);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <>
      <Header />

      <div className="relative flex pt-16 min-h-screen">
        <Sidebar
          groups={dashboardNavGroups}
          expanded={sidebarExpanded}
          onExpandedChange={setSidebarExpanded}
          t={t}
        />

        <div className="min-w-0 flex-1 pb-28 lg:pb-0">
          <main className="px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
            <div className="mb-6 max-w-3xl">
              <div className="flex items-start justify-between gap-4">
                <div>
                </div>
                <button
                  type="button"
                  onClick={() => setDrawerOpen(true)}
                  className="flex size-10 items-center justify-center rounded-lg border border-surface-border text-brand-muted lg:hidden"
                  aria-label={t.mobileNav.openMenu}
                >
                  <Menu size={18} />
                </button>
              </div>
            </div>
            <Outlet />
          </main>
        </div>
      </div>

      <Footer />

      <MobileNavigation
        groups={dashboardNavGroups}
        quickItems={quickNavItems}
        drawerOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        t={t}
      />

      <CommandPalette
        open={commandOpen}
        onClose={() => setCommandOpen(false)}
        groups={dashboardNavGroups}
        t={t}
      />
    </>
  );
}
